import HundredBricksAPIError from '../../../HundredBricksAPIError';
class ProgressError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ProgressError', ...args);
    }
}
export default ProgressError;
